export enum SubRole {
  INITIATOR = "INITIATOR",
  DISTRIBUTOR = "DISTRIBUTOR",
}
